import { ViewIds } from '@ardoq/api-types';
import {
  DEFAULT_REPLACEMENT_FOR_WORKSPACE_MODE,
  isViewEligibleForNewAssets,
} from 'views/environmentals/restrictedViews';
import type { ModeViews } from 'views/modeViews$';
import {
  type FocusedChrome,
  focusedChromeOperations,
} from 'scope/focusedChromeOperations';

export const getRecentlyUsedStartView = ({
  workspaceStartView,
  recentlyUsedViewStyle,
  workspaceModeViewsById,
}: {
  workspaceStartView: ViewIds | null;
  recentlyUsedViewStyle: ViewIds | null;
  workspaceModeViewsById: ModeViews<ViewIds>['byIds'];
}): ViewIds | undefined => {
  if (workspaceStartView || !recentlyUsedViewStyle) {
    return undefined;
  }
  return isViewEligibleForNewAssets(
    workspaceModeViewsById[recentlyUsedViewStyle]
  )
    ? recentlyUsedViewStyle
    : DEFAULT_REPLACEMENT_FOR_WORKSPACE_MODE;
};

export const getActiveTabForOpenedWorkspace = ({
  hasRecentlyUsedViewStyles,
  isViewpointMode,
  presentationId,
  focusedChrome,
  workspaceStartView,
  recentlyUsedViewStyle,
  workspaceModeViewsById,
}: {
  hasRecentlyUsedViewStyles: boolean;
  isViewpointMode: boolean;
  presentationId: string | null;
  focusedChrome: FocusedChrome;
  workspaceStartView: ViewIds | null;
  recentlyUsedViewStyle: ViewIds | null;
  workspaceModeViewsById: ModeViews<ViewIds>['byIds'];
}): ViewIds | undefined => {
  if (
    !hasRecentlyUsedViewStyles ||
    isViewpointMode ||
    presentationId ||
    focusedChromeOperations.isFocusedChrome(focusedChrome)
  ) {
    return undefined;
  }
  return getRecentlyUsedStartView({
    workspaceStartView,
    recentlyUsedViewStyle,
    workspaceModeViewsById,
  });
};
